const apiDocs = [
    {
        id: 1,
        apiName: "library_public_getResourceIssuerDetails",
        title: "Get Resource Issuer Details",
        description:
            "Returns user details along with all library resources currently issued to the user.",

        method: "POST",
        baseUrl: "https://portal.vmedulife.com/api/library/libraryPublicIntegration.php",

        input: "eyJ1c2VySWQiOiJTVFNURzI0MTgyOSJ9",

        requestParams: [
            {
                name: "userId",
                required: true,
                desc: "User ERP ID (Student/Employee unique identifier)"
            }
        ],

        successResponse: {
            "data": {
                "name": "SAMEER SAYYED",
                "TotalIssuedResources": 2,
                "issuer": "available",
                "role": "student",
                "userid": 31899,
                "father_full_name": "",
                "mother_fullname": "",
                "admissionNumber": "",
                "studentid": "STSTG241951",
                "student_email_id": "SAMEER@gmail.com",
                "user_text_id": "STSTG241951",
                "profilePhoto": "/images/display_profie_pic.jpg",
                "studentIID": 113,
                "userInstituteName": "VM Stage",
                "defaultStreamGroupData": {
                    "groupId": 1847,
                    "sid": 267,
                    "streamName": "Computer Engineering ",
                    "groupname": "semester_2_91200012",
                    "batchText": "",
                    "parentGroupName": "2nd Year",
                    "yearId": 11,
                    "yearname": "2025-26",
                    "rollNumber": "",
                    "serialNumber": "",
                    "seatNumber": ""
                },
                "access": "open",
                "issuedResources": {
                    "1955": {
                        "title": "A Text Book of Human Anatomy Physiology",
                        "uniqueId": 31899,
                        "author": "Maheshwari.B",
                        "accessionnumber": "3",
                        "accession_series_id": 12,
                        "accession_series": null,
                        "resource_copy_id": 203,
                        "resource_id": "",
                        "issued_date": "2026-01-13",
                        "collected_fine": 0,
                        "waived_fine_amount": 0,
                        "balance_fine_amount": 0,
                        "dueDate": "18 Jan 2026",
                        "return_date": "0000-00-00",
                        "status": "issued",
                        "fine_amount": 0,
                        "user_id": 31899,
                        "user_role": "student",
                        "added_on": "2026-01-13 08:58:40",
                        "added_by": 3149,
                        "last_update": "2026-01-13 08:58:40",
                        "price": 220,
                        "policy_id": 15,
                        "policyName": "",
                        "resourseInstituteName": "VM Stage",
                        "resourceStreamId": "[\"267\"]",
                        "resourcePeriodicalType": "resource",
                        "lateFine": 0,
                        "damagedPrice": "110.00",
                        "lostPrice": "176.00",
                        "isOverdue": false
                    }
                },
                "totalLateFine": "350.00"
            },
            "success": "true",
        },

        errorResponse: {
            "data": {

                "name": "",
                "TotalIssuedResources": 0,
                "issuer": "Not available",
                "issuedResources": [],
                "totalLateFine": 0
            },
            "success": "true",
            "status": "fail"
        }
        ,

        curlURL: `
            'https://portal.vmedulife.com/api/library/libraryPublicIntegration.php' \\
            --form 'library_public_getResourceIssuerDetails=true' \\
            --form 'data=eyJ1c2VySWQiOiJTVFNURzI0MTgyOSJ9' \\
            --form 'secretKey=MhDeXA6F2YbdpmIYpX49oUvkLdryhIJq'
        `
    },

    {
        id: 2,
        apiName: "library_public_getResourceDetails",
        title: "Get Resource Details",
        description:
            "Fetches complete details of a library resource using accession details.",

        method: "POST",
        baseUrl: "https://portal.vmedulife.com/api/library/libraryPublicIntegration.php",

        input: "eyAiQWNjZXNzaW9uRGV0YWlscyI6ICJWTV9TMl9fOCIgfQo=",

        requestParams: [
            {
                name: "AccessionDetails",
                required: true,
                desc: "Accession Series_Accession Number",
                data: []
            }
        ],

        successResponse: {
            "data": {
                "266": {
                    "title": "fgfdh",
                    "author": "gfdhh",
                    "publisher": "",
                    "publishername": "",
                    "medium": "Physical",
                    "edition": "",
                    "yearOfPublication": "",
                    "resourceCategory": "",
                    "resource_category_name": "",
                    "stream_id": "",
                    "stream_name": "",
                    "price": 1,
                    "resource_condition": "Good",
                    "location": 0,
                    "location_name": "",
                    "isbn_number": "0",
                    "eresource_path": "",
                    "eresource_access": "",
                    "added_on": "2021-04-16 10:00:46",
                    "added_by_id": 1823,
                    "last_update": "2021-04-16 10:00:46",
                    "last_updated_by_id": 0,
                    "volume": "",
                    "invoiceno": 0,
                    "billno": "",
                    "bill_date": "",
                    "discount": 0,
                    "netprice": 0,
                    "resource_lang": "",
                    "number_of_pages": "0",
                    "resource_type": "",
                    "transalated": "Yes",
                    "preliminary_pages": "0",
                    "accessionnumber": "8",
                    "accession_date": "07 Apr 2021",
                    "translator": "",
                    "search_key_word": "",
                    "AccessionText": "VM_S2_",
                    "invoicedetails": "",
                    "parentid": 0,
                    "accession_series_id": 8,
                    "callNumber": "",
                    "resource_status": "available",
                    "resource_attachments": [],
                    "isIssued": false,
                    "addedOn": "16 Apr 2021 | 03:30 PM",
                    "updatedOn": "16 Apr 2021 | 03:30 PM",
                    "added_by_name": "Dummy Stage",
                    "added_by_ERP": "FCSTG1910"
                }
            },
            "success": "true",
            "status": "success",
            "all_resource_data_found": "true",
            "all_location_data_found": "true",
            "all_publisher_data_found": "true",
            "all_stream_data_found": "true",
            "all_invoice_data_found": "true",
            "all_Accessionseries_data_found": "true",
            "count": 1
        },

        errorResponse: {
            "data": [],
            "success": "true",
            "status": "fail",
            "message": "Accession series not found"
        },

        curlURL: `
        'https://portal.vmedulife.com/api/library/libraryPublicIntegration.php' \\
        --form 'library_public_getResourceDetails=true' \\
        --form 'data=eyAiQWNjZXNzaW9uRGV0YWlscyI6ICJWTV9TMl9fOCIgfQo=' \\
        --form 'secretKey=MhDeXA6F2YbdpmIYpX49oUvkLdryhIJq'
        `
    },

    {
        id: 3,
        apiName: "library_public_IssueLibraryResourceToUser",
        title: "Issue Library Resource To User",
        description:
            "Issues a library resource or periodical copy to a user based on policy rules.",

        method: "POST",
        baseUrl: "https://portal.vmedulife.com/api/library/libraryPublicIntegration.php",

        input:
            "eyAidXNlcklkIjogIlNUU1RHMjQxODI5IiwgIkFjY2Vzc2lvbkRldGFpbHMiOiAiMTB0aGp1bHlfc2VyaWVzXzMwMSIsICJwb2xpY3lJZCI6ICIyNyIKfQ==",

        requestParams: [
            { name: "userId", required: true, desc: "User ERP ID (Student/Employee unique identifier)" },
            { name: "AccessionDetails", required: true, desc: "Accession Details" },
            { name: "policyId", required: true, desc: "Library Policy ID" }
        ],

        successResponse: {
            "status": "success",
            "message": "1 resource(s)/periodical(s) issued successfully. ",
            "success": "true",
            "isbookIssued": "true",
            "resourceDueDate": "2026-01-14",
            "issuedIdArray": [
                1956
            ],
            "alreadyIssuedResourceCopies": [],
            "periodicalDailyLogsNotAdded": []
        },

        errorResponse: {
            "status": "fail",
            "message": "Resource/Periodical copy is already issued. Failed to issue resource/periodical. 1 resource(s)/periodical(s) copies are already issued. ",
            "success": "true",
            "isbookIssued": "true",
            "errortype": "Error",
            "issuedIdArray": [],
            "alreadyIssuedResourceCopies": [
                7795
            ],
            "periodicalDailyLogsNotAdded": []
        },

        curlURL: `
            'https://portal.vmedulife.com/api/library/libraryPublicIntegration.php' \\
            --form 'library_public_IssueLibraryResourceToUser=true' \\
            --form 'data=eyAidXNlcklkIjogIlNUU1RHMjQxODI5IiwgIkFjY2Vzc2lvbkRldGFpbHMiOiAiMTB0aGp1bHlfc2VyaWVzXzMwMSIsICJwb2xpY3lJZCI6ICIyNyIKfQ==' \\
            --form 'secretKey=MhDeXA6F2YbdpmIYpX49oUvkLdryhIJq'
        `
    },

    {
        id: 4,
        apiName: "library_public_ReturnRenewLibraryResource",
        title: "Return / Renew Library Resource.",
        description:
            "Return or renew an issued library resource.",

        method: "POST",
        baseUrl: "https://portal.vmedulife.com/api/library/libraryPublicIntegration.php",

        input: "ewogICJ1c2VyRVJQSWQiOiAiU1RTVEcyNDE4MjkiLAogICJBY2Nlc3Npb25EZXRhaWxzIjogIjEwdGhqdWx5X3Nlcmllc18zMDEiLAogICJwb2xpY3lJZCI6ICIyNyIsCiAgInRyYW5zYWN0aW9uX2lkIjogIiIsCiAgInR5cGUiOiAicmV0dXJuIiwKICAibGF0ZUZpbmUiOiAiMTAwLjAwIiwKICAiQ29sbGVjdGVkRmluZSI6ICIwLjAwIiwKICAiZGFtYWdlZExvc3RGaW5lIjogIjAuMDAiLAogICJyZXNvdXJjZV9jb25kaXRpb24iOiAiR29vZCIsCiAgImlzc3VlVHlwZSI6ICJyZXNvdXJjZSIKfQ==",

        requestParams: [
            {
                name: "userERPId",
                required: true,
                desc: "User ERP ID (Student/Employee unique identifier)"
            },
            {
                name: "AccessionDetails",
                required: true,
                desc: "Accession Series_Accession Number"
            },
            {
                name: "policyId",
                required: true,
                desc: "Library policy ID applicable for issue/return transaction"
            },
            {
                name: "transaction_id",
                required: false,
                desc: "Previous transaction ID"
            },
            {
                name: "type",
                required: true,
                desc: "Transaction type (renew / return)"
            },
            {
                name: "lateFine",
                required: true,
                desc: "Late return fine amount"
            },
            {
                name: "CollectedFine",
                required: true,
                desc: "Fine amount collected from the user"
            },
            {
                name: "damagedLostFine",
                required: true,
                desc: "Fine amount for damaged or lost resource"
            },
            {
                name: "resource_condition",
                required: true,
                desc: "Physical condition of the resource at the time of return"
            },
            {
                name: "issueType",
                required: false,
                desc: "Type of library item (resource / periodical)"
            }
        ],

        successResponse: {
            "data": [],
            "success": "true",
            "email_response": null,
            "dueDate": "2026-01-14",
            "fineAmount": 100,
            "status": "success",
            "message": "Resource returned successfully."
        },

        errorResponse: {
            "data": [],
            "success": "true",
            "status": "fail",
            "message": "This resource is already returned."
        },

        curlURL: `
        'https://portal.vmedulife.com/api/library/libraryPublicIntegration.php' \\
        --form 'library_public_ReturnRenewLibraryResource=true' \\
        --form 'data=eyJ1c2VyRVJQSWQiOiAiU1RTVEcyNDE4MjkiLCJBY2Nlc3Npb25EZXRhaWxzIjogIkVGQ0QyXzEwMSIsICJwb2xpY3lJZCI6ICIyNyIsInRyYW5zYWN0aW9uX2lkIjogIiIsInR5cGUiOiAicmV0dXJuIiwibGF0ZUZpbmUiOiAiMTAwLjAwIiwKIkNvbGxlY3RlZEZpbmUiOiAiMC4wMCIsImRhbWFnZWRMb3N0RmluZSI6ICIwLjAwIiwgCiJyZXNvdXJjZV9jb25kaXRpb24iOiAiR29vZCIsImlzc3VlVHlwZSI6ICJyZXNvdXJjZSJ9' \\
        --form 'secretKey=7yXv06zLDKfNy8m4vBx5XnBipMFVa1t1'
        `
    },

    {
        id: 5,
        apiName: "library_public_getAllPolicyDetails",
        title: "Get All Policy Details",
        description:
            "To get the all policy details according to userrole for institute.",
        method: "POST",
        baseUrl: "https://portal.vmedulife.com/api/library/libraryPublicIntegration.php",

        input: "eyJ1c2VySWQiOiJTVFNURzI0MTgyOSJ9",

        requestParams: [
            {
                name: "userId",
                required: true,
                desc: "User ERP ID (Student/Employee unique identifier)"
            }
        ],

        successResponse: {
            "data": {
                "16": {
                    "name": "Policy & name",
                    "description": "Description",
                    "NumberOfResources": "",
                    "NumberOfDays": "",
                    "PerDayFine": "",
                    "ResourceDamagedCost": "",
                    "NumberOfRenewalOfSameIssueResource": "",
                    "ResourceLostCost": "",
                    "rulePolicyInstituteName": "VM Stage"
                },
                "17": {
                    "name": "Policy (Student)",
                    "description": "",
                    "NumberOfResources": "",
                    "NumberOfDays": "",
                    "PerDayFine": "",
                    "ResourceDamagedCost": "",
                    "NumberOfRenewalOfSameIssueResource": "",
                    "ResourceLostCost": "",
                    "rulePolicyInstituteName": "VM Stage"
                }
            },
            "success": "true",
            "status": "success",
            "message": "Library policy details fetched successfully."
        },

        errorResponse: {
            "data": [],
            "success": "true",
            "status": "fail",
            "message": "No library policy data found for this role."
        },

        curlURL: `
            'https://portal.vmedulife.com/api/library/libraryPublicIntegration.php' \\
            --form 'library_public_getAllPolicyDetails=true' \\
            --form 'data=eyJ1c2VySWQiOiJTVFNURzI0MTgyOSJ9' \\
            --form 'secretKey=7yXv06zLDKfNy8m4vBx5XnBipMFVa1t1'
        `
    },
];

export default apiDocs;
